import * as React from 'react';
import EditModeContainer from '../containers/FMGeofenceActionsContainer';
import {
    FMIconButton,
    FMToolbar
} from 'atoms';
import { Props } from '../containers/FMGeofenceActionsContainer';
import { TreeNodeType, GeofenceType, TreeType } from '../../store/FMTree/FMTreeReducer';
import DisabledArea from '../atoms/DisabledArea';

const FMGeofenceActionsToolbar = (props: Props) => (
        <FMToolbar variant="dense">
        {
            props.editModeEnabled && <DisabledArea />
        }
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="edit"
                onClick={() => props.fetchGeotreeNodeData(true)}
                tooltip={fmtools.translate('zone_edit')}
            />
        }
        <FMIconButton
            color="secondary"
            type="showonmap"
            onClick={() => props.showGeofenceOnMap()}
            tooltip={fmtools.translate('ShowOnMap')}
        />
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="geopoint"
                onClick={() => props.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.point)}
                tooltip={fmtools.translate('add_point_zone')}
            />
        }
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="geoline"
                onClick={() => props.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.line)}
                tooltip={fmtools.translate('add_line_zone')}
            />
        }
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="geopolygon"
                onClick={() => props.fetchGeotreeNewNodeData(TreeNodeType.item, GeofenceType.polygon)}
                tooltip={fmtools.translate('add_poligon_zone')}
            />
        }
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="addfolder"
                onClick={() => props.fetchGeotreeNewNodeData(TreeNodeType.group)}
                tooltip={fmtools.translate('add_zone_group')}
            />
        }
        {
            props.allowEditGeoTree && <FMIconButton
                color="secondary"
                type="delete"
                onClick={() => props.deleteSelectedNode(TreeType.geofencesTree, props.treeDisplayState)}
                tooltip={fmtools.translate('delete_zone')}
            />
        }
    </FMToolbar>
);


export default EditModeContainer(FMGeofenceActionsToolbar);